module.exports = __webpack_public_path__ + "img/icon-implantation-05.7f34604f.svg";